import { Button } from "../../../../../../components/Button/Button.tsx";
import { EmptyState } from "../../../../../../components/EmptyState/EmptyState.tsx";
import { TEXT_LAYER_TYPE } from "../../Designer/constants.ts";
import { useCreateLayer } from "../../Designer/hooks/useCreateLayer.ts";

export const TextEmptyState = () => {
  const createLayer = useCreateLayer();

  return (
    <EmptyState
      iconName="Type"
      title="Text"
      description="Place text anywhere to guide your audience."
      className="h-full w-full px-300"
    >
      <Button
        iconName="Plus"
        onClick={() => {
          createLayer({
            layerType: TEXT_LAYER_TYPE,
          });
        }}
      >
        Add a text box
      </Button>
    </EmptyState>
  );
};
